export const ROOT_ID = 'CitySearchInput__ROOT';
